import { z } from "zod/v4";
import { courtSchema } from "../schemas/court";
import { fetchApi, fetchVoid } from "./internal";

export const courts = {
	list: (locationId: string) => fetchApi(`/locations/${locationId}/courts`, z.array(courtSchema)),
	get: (locationId: string, courtId: string) =>
		fetchApi(`/locations/${locationId}/courts/${courtId}`, courtSchema),
	create: (locationId: string, data: unknown) =>
		fetchApi(`/locations/${locationId}/courts`, courtSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	update: (locationId: string, courtId: string, data: unknown) =>
		fetchApi(`/locations/${locationId}/courts/${courtId}`, courtSchema, {
			method: "PATCH",
			body: JSON.stringify(data),
		}),
	delete: (locationId: string, courtId: string) =>
		fetchVoid(`/locations/${locationId}/courts/${courtId}`, {
			method: "DELETE",
		}),
};
